module.exports = __webpack_public_path__ + "img/aboutme.c55f6029.svg";